import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const [type, setType] = useState("agency");
  const [form, setForm] = useState({ first:"", last:"", email:"", phone:"", agency:"", need:"", message:"", consent:false });
  const [status, setStatus] = useState({ state:"idle", msg:"" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.first || !form.last || !form.email) {
      setStatus({ state:"error", msg:"Please add your name and email." });
      return;
    }
    setStatus({ state:"sending", msg:"Sending…" });
    try {
      await axios.post(`${API}/contact`, { ...form, type });
      setStatus({ state:"success", msg:"Thanks — message received. Laura will be in touch within one business day." });
      setForm({ first:"", last:"", email:"", phone:"", agency:"", need:"", message:"", consent:false });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setStatus({ state:"error", msg: typeof d === "string" ? d : "Something went wrong. Please email laura@peopleology.co directly." });
    }
  };

  const update = (k) => (e) => setForm({...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value});

  return (
    <>
      <div className="page-hero">
        <span className="page-hero-eyebrow">Get in touch</span>
        <h1>Let's start<br />with a<br /><em>conversation.</em></h1>
        <p>No forms that go nowhere. No junior coordinators. When you reach out to Peoplology, you hear back from Laura — personally, within one business day.</p>
      </div>

      <section className="section section-black">
        <div className="two-col" style={{alignItems:'start'}}>
          <div>
            <span className="eyebrow">How to reach us</span>
            <h2 className="h-md" style={{color:'var(--white)',marginBottom:'2.5rem'}}>We're easy<br />to get hold of.</h2>

            <div className="contact-method">
              <div className="contact-icon">@</div>
              <div>
                <div className="contact-method-label">Email</div>
                <div className="contact-method-value"><a href="mailto:hello@peopleology.co">hello@peopleology.co</a></div>
                <div className="contact-method-sub">Best for detailed enquiries — Laura reads every one.</div>
              </div>
            </div>
            <div className="contact-method">
              <div className="contact-icon">in</div>
              <div>
                <div className="contact-method-label">LinkedIn</div>
                <div className="contact-method-value"><a href="https://www.linkedin.com/in/peopleology/" target="_blank" rel="noopener noreferrer">Laura Hurle on LinkedIn</a></div>
                <div className="contact-method-sub">Connect, follow and join the conversation.</div>
              </div>
            </div>
            <div className="contact-method">
              <div className="contact-icon">◎</div>
              <div>
                <div className="contact-method-label">Locations</div>
                <div className="contact-method-value">Geelong &nbsp;·&nbsp; Melbourne &nbsp;·&nbsp; Greater Victoria</div>
                <div className="contact-method-sub">Placing and consulting nationally across Australia.</div>
              </div>
            </div>

            <div style={{marginTop:'3rem',borderLeft:'2px solid var(--gold)',paddingLeft:'2rem'}}>
              <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.65)',lineHeight:1.75,fontStyle:'italic',fontWeight:300,marginBottom:'0.75rem'}}>“I read and respond to every message personally. You won't get an auto-reply and then silence — I'll actually get back to you.”</p>
              <p style={{fontSize:'0.78rem',color:'var(--gold)',fontWeight:700}}>— Laura Hurle, Founder</p>
            </div>

            <div style={{marginTop:'3rem'}}>
              <span className="eyebrow">What happens next</span>
              {[
                ["01","You hear back from Laura","Within one business day — usually sooner. By email or phone, whichever you prefer."],
                ["02","A 20-minute discovery call","We learn about your agency, your challenges, and what you actually need. No pitch, no pressure."],
                ["03","A clear plan forward","We'll tell you honestly how we can help — and if we're not the right fit, we'll say that too."]
              ].map(([n,h,p])=>(
                <div key={n} className="next-step">
                  <div className="next-num">{n}</div>
                  <div><h4>{h}</h4><p>{p}</p></div>
                </div>
              ))}
            </div>
          </div>

          <form onSubmit={handleSubmit} style={{background:'var(--black2)',border:'1px solid var(--border)',padding:'3rem'}}>
            <h3 style={{fontSize:'1.2rem',fontWeight:800,color:'var(--white)',marginBottom:'0.5rem'}}>Send us a message</h3>
            <p style={{fontSize:'0.85rem',color:'rgba(255,255,255,0.70)',marginBottom:'2.5rem',fontWeight:300}}>Tell us what you need and we'll come back with the right next step.</p>

            <div style={{display:'flex',gap:'1.5rem',marginBottom:'1.5rem',flexWrap:'wrap'}}>
              {[["agency","Agency / Principal"],["candidate","Candidate"],["speaking","Speaking enquiry"]].map(([v,l])=>(
                <label key={v} style={{display:'flex',alignItems:'center',gap:'8px',fontSize:'0.82rem',color:'rgba(255,255,255,0.80)',cursor:'pointer'}}>
                  <input type="radio" name="type" value={v} checked={type===v} onChange={()=>setType(v)} style={{accentColor:'var(--gold)'}} /> {l}
                </label>
              ))}
            </div>

            <div className="form-row">
              <div className="form-group"><label>First name</label><input type="text" placeholder="Jane" value={form.first} onChange={update("first")} /></div>
              <div className="form-group"><label>Last name</label><input type="text" placeholder="Smith" value={form.last} onChange={update("last")} /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Email</label><input type="email" placeholder="jane@agency.com.au" value={form.email} onChange={update("email")} /></div>
              <div className="form-group"><label>Phone</label><input type="tel" placeholder="04XX XXX XXX" value={form.phone} onChange={update("phone")} /></div>
            </div>
            <div className="form-group"><label>Agency / Company</label><input type="text" placeholder="Your agency name" value={form.agency} onChange={update("agency")} /></div>
            <div className="form-group">
              <label>What do you need help with?</label>
              <select value={form.need} onChange={update("need")}>
                <option value="">Select...</option>
                <option>Strategic Business Review</option>
                <option>Recruitment — finding someone to hire</option>
                <option>Remuneration Benchmarking</option>
                <option>Culture &amp; Growth</option>
                <option>People &amp; Culture Diagnostic</option>
                <option>Workshop</option>
                <option>Speaking enquiry</option>
                <option>I'm a candidate looking for a role</option>
                <option>Not sure — I'd like to talk it through</option>
              </select>
            </div>
            <div className="form-group"><label>Tell us more</label><textarea placeholder="Give us as much context as you're comfortable sharing. The more detail, the better we can help in our first conversation." value={form.message} onChange={update("message")} /></div>
            <div style={{display:'flex',gap:'0.75rem',alignItems:'flex-start',marginBottom:'1.75rem'}}>
              <input type="checkbox" id="consent" checked={form.consent} onChange={update("consent")} style={{marginTop:'3px',flexShrink:0,accentColor:'var(--gold)'}} />
              <label htmlFor="consent" style={{fontSize:'0.78rem',color:'rgba(255,255,255,0.55)',lineHeight:1.6}}>I'm happy for Peoplology to keep my details and contact me about relevant opportunities or services.</label>
            </div>
            <button type="submit" disabled={status.state==="sending"} className="btn btn-gold" style={{display:'block',textAlign:'center',width:'100%',padding:'16px',opacity:status.state==="sending"?0.7:1,cursor:status.state==="sending"?"wait":"pointer"}}>{status.state==="sending"?"Sending…":"Send message →"}</button>
            {status.state==="success" && <p style={{textAlign:'center',fontSize:'0.85rem',color:'var(--gold)',marginTop:'1rem'}}>{status.msg}</p>}
            {status.state==="error" && <p style={{textAlign:'center',fontSize:'0.85rem',color:'#ff9b9b',marginTop:'1rem'}}>{status.msg}</p>}
            {status.state==="idle" && <p style={{textAlign:'center',fontSize:'0.72rem',color:'rgba(255,255,255,0.55)',marginTop:'1rem'}}>We'll respond within one business day.</p>}
          </form>
        </div>
      </section>

      <section className="section" style={{background:'var(--black2)',textAlign:'center',padding:'60px 5vw',borderTop:'1px solid var(--border)'}}>
        <p style={{fontSize:'0.8rem',color:'rgba(255,255,255,0.55)',letterSpacing:'0.04em'}}>hello@peopleology.co &nbsp;·&nbsp; Geelong · Melbourne · Greater Victoria &nbsp;·&nbsp; ABN: 92 397 706 507</p>
      </section>
    </>
  );
};

export default Contact;
